export default "__VITE_ASSET__tQ8X$w$z__"